// src/services/autoProductsService.js
import axios from 'axios';

export default {
  // Get all auto products for the company
  getAllAutoProducts() {
    return axios.get('/restaurant/areas/auto-products');
  },

  // Get auto products for a specific restaurant area
  getAutoProductsByAreaId(areaId) {
    return axios.get(`/restaurant/areas/${areaId}/auto-products`);
  },

  // Create a new auto product mapping
  createAutoProduct(autoProductData) {
    return axios.post('/restaurant/areas/auto-products', autoProductData);
  },

  // Update an existing auto product mapping
  updateAutoProduct(autoProductId, autoProductData) {
    return axios.put(`/restaurant/areas/auto-products/${autoProductId}`, autoProductData);
  },

  // Delete an auto product mapping
  deleteAutoProduct(autoProductId) {
    return axios.delete(`/restaurant/areas/auto-products/${autoProductId}`);
  }
}
